import React, { Component } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar'
import moment from 'moment'
import { GOOGLE_API_KEY, SCHEDULE_ID, CLOSED_ID, EVENTS_ID } from './config.js';
import "react-big-calendar/lib/css/react-big-calendar.css";
/* global gapi */
import CalendarPopUp from '../../components/UI/CalendarPopUp/CalendarPopUp';

const localizer = momentLocalizer( moment );

class GoogleCalendar extends Component {
    state = {
        events: [
        ],
        showEvent: false,
        popUp: {
            title: '',
            time: '',
            key: '',
            recurring: '',
            idx: 0,
            location: {
                x: 0,
                y: 0
            }
        },
        mouseLocation: {
            x: 0,
            y: 0
        }
    }

    componentDidMount () {
        this.getSchedule();
    }

    loadGoogle = ( id, whichCall ) => {
        const that = this;
        gapi.client
            .init( {
                apiKey: GOOGLE_API_KEY
            } )
            .then( function () {
                return gapi.client.request( {
                    path: `https://www.googleapis.com/calendar/v3/calendars/${id}/events?timeMin=${moment().toISOString()}`
                } );
            } )
            .then(
                response => {
                    const events = [];
                    response.result.items.forEach( item => {
                        let event = {}
                        if( item.status !== 'cancelled' ) {
                            if( item.start.dateTime ) {
                                event = {
                                    id: item.id,
                                    title: item.summary,
                                    start: new Date( item.start.dateTime ),
                                    end: new Date( item.end.dateTime ),
                                    calendar: whichCall
                                }
                            } else {
                                event = {
                                    id: item.id,
                                    title: item.summary,
                                    start: new Date( item.start.date ),
                                    end: new Date( item.end.date ),
                                    allDay: true,
                                    calendar: whichCall
                                }
                            }
                        }

                        events.push( event );
                    } )
                    that.googleGot( events );
                }
            )

    }

    getSchedule = () => {
        gapi.load( 'client', { callback: () => this.loadGoogle( EVENTS_ID, 'events' ) } );
        gapi.load( 'client', { callback: () => this.loadGoogle( SCHEDULE_ID, 'schedule' ) } );
        gapi.load( 'client', { callback: () => this.loadGoogle( CLOSED_ID, 'closed' ) } );
    }

    googleGot = ( events, whichCall ) => {
        const updatedEvents = [ ...this.state.events ];
        updatedEvents.push( ...events );
        this.setState( { events: updatedEvents } );
    }

    eventStyler = ( event ) => {
        const style = { backgroundColor: '#039BE5' };
        switch( event.calendar ) {
            case 'schedule':
                style.backgroundColor = '#EF6C00';
                break;
            case 'events':
                style.backgroundColor = '#039BE5';
                break;
            case 'closed':
                style.backgroundColor = '#AD1457';
                break;
            default:
                break;

        }

        return {
            style: style
        }
    }
    selectEvent = ( event ) => {
        const newLocation = {
            x: this.state.mouseLocation.x - 100,
            y: this.state.mouseLocation.y - 125
        }
        const startTime = moment( event.start );
        let time = '';
        if( event.allDay ) {
            time = startTime.format( 'dddd, MMMM Do YYYY' );
        } else {
            const endTime = moment( event.end );
            if( event.start.getDate() === event.end.getDate() ) {
                time = `${startTime.format( 'dddd, MMMM Do YYYY, h:mm a' )} - ${endTime.format( 'h:mm a' )}`;
            } else {
                time = `${startTime.format( 'dddd, MMMM Do YYYY, h:mm a' )} - ${endTime.format( 'dddd, MMMM Do YYYY, h:mm a' )}`;
            }
        }
        const events = this.state.events;
        const idx = events.indexOf( event );
        this.setState( {
            showEvent: true,
            popUp: {
                title: event.title,
                time: time,
                location: newLocation,
                idx: idx,
                resourceId: 0
            }
        } );
    }

    _OnMouseMove ( e ) {
        this.setState( { mouseLocation: { x: e.pageX, y: e.pageY } } );
    }


    closePopUp = () => {
        this.setState( { showEvent: false } );
    }

    render () {
        return (
            <div onMouseMove={this._OnMouseMove.bind( this )}>
                <CalendarPopUp
                    popUpInformation={this.state.popUp}
                    showEvent={this.state.showEvent}
                    close={this.closePopUp} />
                <Calendar
                    localizer={localizer}
                    events={this.state.events}
                    style={{ height: 1000 }}
                    eventPropGetter={( this.eventStyler )}
                    onSelectEvent={this.selectEvent}
                    startAccessor="start"
                    endAccessor="end"
                    popup={false}
                    step={60}
                />
            </div>
        )
    }
}

export default GoogleCalendar;